<h3>Got a question?</h3>
<p>We're here to help</p>
<a class="link" [href]="faqLink" target="_blank">Find answers here</a>
